import axios from "axios";
import {
  Button,
  IconButton,
} from "@mui/material";
import styles from "./style.module.css";
import SearchIcon from "@mui/icons-material/Search";
import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import Box from "@mui/material/Box";
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  DataGrid,
  GridColDef,
  GridFilterModel,
  GridToolbar,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import CircularModal from '../../custom/circularModalLoader/circularModalLoader';
import ReportsTable from '../../custom/reportsTable';
import DownloadIcon from '@mui/icons-material/Download';
import { CalendarIcon, LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment, { MomentInput } from "moment";
import { pvcStockOrderDetails } from "../../../utils/constant";
import Title from "../../custom/Title";
import { getStockOrdersReport } from "../../../services/Reports";
import useService from "../../../hooks/useService";

const DataGridContainer = styled.div`
  height: calc(100%);
  overflow-x: auto;
`
export const StockOrders= () => {
  let sessionId: any = localStorage.getItem("sessionId")
  const [loading, setLoading] = useState(false);
  const [pvcStockOrders, setPvcStockOrders] = useState<any>([])
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 })
  const [totalCount, setTotalCount] = useState<number>(0)
  const [fromDate, setFromDate] = useState<any>(new Date().toString())
  const [toDate, setToDate] = useState<any>(new Date().toString())
  const { execute } = useService()


  const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
    items: [],
    quickFilterExcludeHiddenColumns: true,
    quickFilterValues: [],
  })

  const checkDateDifference = (fromDate: Date, toDate: Date) => {
    const fromDateObj = new Date(fromDate)
    const toDateObj = new Date(toDate)
    const differenceInTime = toDateObj.getTime() - fromDateObj.getTime()
    const differenceInDays = differenceInTime / (1000 * 3600 * 24)

    if (differenceInDays > 30) return true
    else return false
  }

   const getPvcStockData = async () => {
    try {
      let dateRange = checkDateDifference(fromDate, toDate)
    //   if(dateRange) return errorToast('Date range should be less than 30 days!')

      setLoading(true)
      const params = {
        // sessionId: sessionId,
        fromDate,
        toDate,
        // page: paginationModel.page,
        // pageSize: paginationModel.pageSize
      }

    //   const response = await axios.post(
    //     "/api/pvcReports/getStockOrders",
    //     params
    //   )
      const { data } = await execute(() => getStockOrdersReport({params}))

      

      setLoading(false)
      setPvcStockOrders(data?.data || [])
      // setTotalCount(response.data?.totalCount || 0)
    } catch (error) {
      setLoading(false)
      console.error(error)
    //   errorToast('Unable to get pvc sto orders!')
    }
  }

  const getPvcStockDataColumns = () => {
    let minWidth = 100

    return pvcStockOrderDetails.map((inboundField: any) => {

      const row: GridColDef = {
        field: inboundField.id,
        headerName: inboundField.label,
        minWidth,
        align: 'left'
      }

      switch (inboundField.id) {
        case "skuId":
          row.minWidth = 200;
          row.renderCell = params => {
            return params.row.skuId ? params.row.skuId : "N/A"
          }
          break;
        case "metal":
          row.minWidth = 120;
          row.renderCell = params => {
            return params.row.metal ? params.row.metal : "N/A"
          }
          break;
        case "purity":
          row.minWidth = 120;
          row.renderCell = params => {
            return params.row.purity ? params.row.purity : "N/A"
          }
          break;
        case "quantity":
          row.minWidth = 120;
          row.renderCell = params => {
            return params.row.quantity ?? 0
          }
          break;
        case "weight":
          row.minWidth = 150;
          row.renderCell = params => {
            return params.row.weight ?? 0
          }
          break;
        case "fineWeight":
          row.minWidth = 150;
          row.renderCell = params => { 
            return params.row.fineWeight ?? 0
          }
          break;
        case "dimensions":
          row.minWidth = 100;
          row.renderCell = params => {
            return params.row.dimensions ? params.row.dimensions : "N/A"
          }
          break;
        case "totalRate":
          row.minWidth = 150;
          row.renderCell = params => {
            return params.row.totalRate ?? 0
          }
          break;
        case "shipper":
          row.minWidth = 400;
          row.renderCell = params => {
            return params.row.shipper ? params.row.shipper : "N/A"
          }
          break;
        case "destination":
          row.minWidth = 400;
          row.renderCell = params => {
            return params.row.destination ? params.row.destination : "N/A"
          }
          break;
        case "productName":
          row.minWidth = 200;
          row.renderCell = params => {
            return params.row.productName ? params.row.productName : "N/A"
          }
          break;
        case "description":
          row.minWidth = 250;
          row.renderCell = params => {
            return params.row.description ? params.row.description : "N/A"
          }
          break;
        case "shape":
          row.minWidth = 100;
          row.renderCell = params => {
            return params.row.shape ? params.row.shape : "N/A"
          }
          break;
        case "mtsTransferType":
            row.minWidth = 100;
            row.renderCell = params => {
              return params.row.mtsTransferType ? params.row.mtsTransferType : "internal"
            }
          break;
        case "createdAt":
            row.minWidth = 180;
            row.renderCell = params => {
              return params.row.createdAt
            }
          break;  
        case "acknowledgedDate":
            row.minWidth = 180;
            row.renderCell = params => {
              return params.row.acknowledgedDate
            }
          break;  
        case "acknowledgementStatus":
            row.minWidth = 180;
            row.renderCell = params => {
              return params.row.acknowledgementStatus
            }
          break;
        case "serialNumber":
            row.minWidth = 100;
            row.renderCell = params => {
              return params.row.serialNumber ?? 'N/A'
            }
          break;
        case "documentNumber":
        case "date":
        case "createdBy":
        case "metalOutTime":
        case "metalOutUpdatedTime":
        case "logisticName":
            row.minWidth = 200;
          break;
        default:
          row.minWidth = 100
          break;
      }
      return row;
    })
  }

  const filterModal = () => {
    return (
      <Box className={styles.filterModal}>
        <Box className={styles.filterModalRow}>
          <Box className={styles.boxModal}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <MobileDatePicker
                slotProps={{
                  textField: { fullWidth: true, size: 'small' },
                    field: {
                      InputProps: {
                      endAdornment: <IconButton><CalendarIcon /></IconButton>
                    }
                  }
                }}
                label='Start Date'
                onChange={(value) => setFromDate(value?.toString()!)}
                value={moment(fromDate || new Date().toString() as MomentInput)}
              />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <MobileDatePicker
                slotProps={{
                  textField: { fullWidth: true, size: 'small' },
                    field: {
                      InputProps: {
                      endAdornment: <IconButton><CalendarIcon /></IconButton>
                    }
                  }
                }}
                label='End Date'
                onChange={(value) => setToDate(value?.toString()!)}
                value={moment(toDate || new Date().toString() as MomentInput)}
              />
            </LocalizationProvider>
          </Box>
          <Box >
            <Button
              variant="contained"
              onClick={getPvcStockData}
              endIcon={<SearchIcon />}
              disabled={!fromDate || !toDate}
            >
              Apply Filter
            </Button>
          </Box>
          {/* <Box >
            <Button
              variant="contained"
              onClick={() => setShowIssueModal('true')}
              endIcon={<DownloadIcon />}
              disabled={pvcStockOrders.length <= 0}
            >
              Export All
            </Button>
          </Box> */}
        </Box>
      </Box>
    )
  }

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        <GridToolbarExport csvOptions={{ fileName: 'stockOrder' }} />
      </GridToolbarContainer>
    )
  }

  const renderTable = () => {
    return (
      <>
        <div>
          {loading && <CircularModal thickness={4} />}
          <Box sx={{ width: "100%", height: '500px', overflow: 'auto' }}>
            <DataGridContainer>
              <ReportsTable
                className="payrollGrid"
                rows={pvcStockOrders || []}
                columns={getPvcStockDataColumns()}
                getRowId={(row) => row.id}
                disableRowSelectionOnClick={true}
                rowHeight={50}
                slots={{ toolbar: CustomToolbar }}
                hideFooter={true}
                fixedHeight={true}
              />
            </DataGridContainer>
          </Box>
        </div>
      </>
    );
  }

  // useEffect(() => {
  //   getPvcStockData()
  // }, [paginationModel.page])

  return (
    <Box className={styles.container}>
    <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Stock Order Report</Title>
      {filterModal()}
      {renderTable()}
    </Box>
  )
}

